'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popup = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _Product = require('./Product');

var _BaseButton = require('../components/BaseButton/BaseButton');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup = exports.Popup = (_temp = _class = function Popup() {
  (0, _classCallCheck3.default)(this, Popup);
}, _class.buttonTheme = function (productName) {
  return productName === _Product.PRODUCT_NAMES.Classica || productName === _Product.PRODUCT_NAMES.Qello ? _BaseButton.ButtonTheme.CallToAction : '';
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Popup.js
// module id = 61
// module chunks = 0